module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NSIgaGVpZ2h0PSI3NSIgdmlld0JveD0iMCAwIDc1IDc1Ij4KICAgIDxwYXRoIGZpbGw9IiM4RThFOEUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTM3LjUgMzcuNWMxMC4zMTMgMCAxOC43NS04LjQzOCAxOC43NS0xOC43NUM1Ni4yNSA4LjQzNyA0Ny44MTIgMCAzNy41IDAgMjcuMTg3IDAgMTguNzUgOC40MzggMTguNzUgMTguNzVjMCAxMC4zMTMgOC40MzggMTguNzUgMTguNzUgMTguNzV6bTAgOS4zNzVjLTEyLjY1NiAwLTM3LjUgNi4wOTQtMzcuNSAxOC43NVY3NWg3NXYtOS4zNzVjMC0xMi42NTYtMjQuODQ0LTE4Ljc1LTM3LjUtMTguNzV6IiBvcGFjaXR5PSIuNjYyIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/default-user-profile.svg
// module id = se8Q
// module chunks = 4